export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "agro_exporter": {
            "basic_container_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logística"])},
            "uniq_final_packing_list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packing"])},
            "container_quality": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calidad"])}
          },
          "packing_house": {
            "process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso"])},
            "quality_control": {
              "process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calidad"])}
            }
          },
          "customer": {
            "basic_containers_query": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Consulta de contenedores"])}
          },
          "edit_password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cambiar contraseña"])},
          "close_sesion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar sesión"])}
        }
      },
      "en": {
        "labels": {
          "agro_exporter": {
            "basic_container_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logistics"])},
            "uniq_final_packing_list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packing"])},
            "container_quality": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality"])}
          },
          "packing_house": {
            "process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Process"])},
            "quality_control": {
              "process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality"])}
            }
          },
          "customer": {
            "basic_containers_query": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers query"])}
          },
          "close_sesion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close session"])},
          "edit_password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit password"])}
        }
      }
    }
  })
}